import { createContext } from 'react';

// Links the pricing tab's SVG header (FrankSolutionSvgTable) to the machine actually selected in the price
// dropdowns (UserUnitPrice). QuoteBuilderNavColumn -- the shared parent of the header and the price form --
// provides the reporter; each machine price field reports the machine it is set to, keyed by column
// ('printing' / 'die_cutting'), so the header names that machine instead of the manufacturing line from step 1.
// null default: no reporter (e.g. the legacy page), so the price field's report is a harmless no-op there.
export const SelectedMachinesContext = createContext(null);
